/* eslint-disable */
/// This file is auto generated - do not edit manually
export * as ReviewReportQuickView from './trans-website-productreview-reviewreport-reviewreportquickview';

export const CustomersSays = 'Website.ProductReview.ReviewReport.CustomersSays';
export const MoreReviews = 'Website.ProductReview.ReviewReport.MoreReviews';
export const AIExplainerButton = 'Website.ProductReview.ReviewReport.AIExplainerButton';
